import useUserInteractions from '@/services/useUserInteractions';
import { IMAGE_SHAPES, IMAGE_SIZES } from '@/components/dorsaImage/imageTypes';
import textConstant from '@/dictionaries/fa.json';
import DorsaImage from '@/components/dorsaImage/DorsaImage';
import { CONTENT_TYPES, LOG_COLLECTOR_USER_AGENT_DATA } from '@/constants/generalConstants';
import Link from 'next/link';

export interface ArticleListCardProps {
    id: string;
    title: string;
    horizontalPoster: string;
    actionDestination: string;
    alt: string;
    authorName?: string;
    date?: string;
    tags?: string[];
}

function ArticleListCard({
    id,
    title,
    horizontalPoster,
    actionDestination,
    alt,
    authorName = 'نازنین حسنی',
    date = 'تیر 1402',
    tags
}: ArticleListCardProps) {
    // todo: check changes after migrating to next app
    const { addViewMutateAsync, logContentMutateAsync } = useUserInteractions();

    return (
        <Link
            id={id}
            href={actionDestination}
            className="article-list-card"
            onClick={() => {
                addViewMutateAsync({
                    objectId: id,
                    objectType: CONTENT_TYPES.article,
                    userAgentData: LOG_COLLECTOR_USER_AGENT_DATA
                });
                logContentMutateAsync({
                    objectId: id,
                    objectType: CONTENT_TYPES.article,
                    tags
                });
            }}>
            <DorsaImage
                src={horizontalPoster}
                className="article-list-card-img"
                alt={alt}
                config={{
                    shape: IMAGE_SHAPES.HORIZONTAL,
                    size: IMAGE_SIZES.SIZE_2
                }}
            />
            <div className="bottom-part-container">
                <h2 className="bottom-part-title">{title}</h2>
                <div className="bottom-part-author-data-row">
                    <div className="author-data-container">
                        <DorsaImage
                            src={horizontalPoster}
                            alt="author-avatar"
                            className="bottom-part-avatar"
                            config={{ shape: IMAGE_SHAPES.SQUARE, size: IMAGE_SIZES.THUMBNAIL }}
                        />
                        <span className="bottom-part-author-name">
                            {authorName}، {date}
                        </span>
                        <span className="bottom-part-read-more">{textConstant.readMore}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default ArticleListCard;
